enum ForecastMode {
  Inventory = 'inventory',
  Audience = 'audience',
}

export default ForecastMode;
